import { EntityIcon } from '@common/Entity/EntityIcons';
import { SnowflakePwdAuthBanner } from '@common/Fabric/SnowflakePwdAuthBanner';
import { ProjectHeader } from '@common/Header/PageHeader';
import { useHasAnalystFabric } from '@common/onboarding/hooks';
import { HUB_TYPE, HUB_URL } from '@common/packageHub/constants';
import { Entity } from '@common/types/Entity';
import {
  MetadataPageContainer,
  MultiSelectWithCheckboxDropdownGlobalStyles,
  Stack,
  TabPane,
  Tabs,
  TabVariant
} from '@prophecy/ui-v3';
import DocumentTitle from '@prophecy/utils/react/DocumentTitle';
import { useSearchParams } from 'react-router-dom';

import { HUB_TAB } from './constants';
import { PackageHub } from './PackageHub';
import { TemplateHub } from './Template';

export default function Hub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabType = searchParams.get('type');
  const activeTab = tabType === HUB_TYPE.TEMPLATE ? HUB_TYPE.TEMPLATE : HUB_TYPE.PACKAGE;

  const hasAnalystFabric = useHasAnalystFabric();
  const showTemplateHub = hasAnalystFabric;
  const header = (
    <ProjectHeader
      crumbs={[
        {
          children: 'Package Hub',
          icon: <EntityIcon size='m' entity={Entity.Package} />,
          elementType: 'link',
          to: HUB_URL.PACKAGE,
          'data-test-id': 'hub-package-hub-crumb-link'
        }
      ]}
    />
  );

  const main = showTemplateHub ? (
    <Tabs
      variant={TabVariant.white}
      activeKey={activeTab}
      onChange={(tab) => setSearchParams({ ...Object.fromEntries(searchParams), type: tab })}>
      <TabPane key={HUB_TYPE.PACKAGE} tab={HUB_TAB.PACKAGE}>
        <PackageHub />
      </TabPane>
      <TabPane key={HUB_TYPE.TEMPLATE} tab={HUB_TAB.TEMPLATE}>
        <TemplateHub />
      </TabPane>
    </Tabs>
  ) : (
    <PackageHub />
  );

  return (
    <Stack height='100%' width='100%'>
      <DocumentTitle title='Packages' />
      <MultiSelectWithCheckboxDropdownGlobalStyles />
      <MetadataPageContainer banner={<SnowflakePwdAuthBanner />} header={header} main={main}></MetadataPageContainer>
    </Stack>
  );
}
